export const CONVERT = {
  Ten: 4,
  Nine: 4,
  Eight: 3.67,
  Seven: 3.33,
  Six: 3.00,
  Five: 2.67,
  Four: 2.33,
  Three: 2,
  Two: 1.67,
  one: 1.33
};

